import type { IssueStatus } from "@/domains/pm/types";
import { StatusFormDialog } from "./StatusFormDialog";
import { DeleteStatusDialog } from "./DeleteStatusDialog";
import type { useCustomStatusRow } from "./useCustomStatusRow";

/**
 * The create / edit / delete dialogs every status dropdown needs, mounted
 * once beside whichever list opened them. Extracted so the single-select
 * picker and the filter checklist share one wiring rather than each growing
 * their own copy.
 */
export function StatusManagementDialogs({
  admin,
  onCreated,
}: {
  admin: ReturnType<typeof useCustomStatusRow>;
  onCreated?: (key: IssueStatus) => void;
}) {
  if (admin.buildingProjectId == null) return null;
  return (
    <>
      <StatusFormDialog
        open={admin.formOpen}
        onOpenChange={admin.setFormOpen}
        buildingProjectId={admin.buildingProjectId}
        editing={admin.editingRow}
        onSaved={(key) => {
          // Creating a status from a picker means you wanted to use it, so
          // selecting it is the point. Editing one leaves the selection alone
          // — the issue already has whatever status it had.
          if (!admin.editingRow) onCreated?.(key);
        }}
      />
      <DeleteStatusDialog
        open={admin.deleteOpen}
        onOpenChange={admin.setDeleteOpen}
        status={admin.deletingRow}
      />
    </>
  );
}
